// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ldap-settings .box-configurations {
  margin-top: 10px;
  margin-bottom: 10px;
}

.ldap-settings .box-configuration {
  margin-top: 0;
  margin-bottom: 12px;
}

.ldap-settings .box-configuration:last-of-type {
  margin-bottom: 0;
}

.ldap-settings .box-body-configuration {
  background: #f5f5f5;
}

.ldap-settings .box-header-configuration {
  cursor: pointer;
}

.ldap-settings .table-noborder > tbody > tr > td {
  border: 0;
}

.ldap-settings .ldap-settings__select-cert {
  min-width: 200px;
}

.ldap-settings .ldap-settings__account-suffixes--wrapper {
  min-width: 250px;
}

.ldap-settings .react-tagsinput {
  overflow: auto;
}

.ldap-settings .react-tagsinput-tag {
  color: inherit;
  background: none;
  border-color: #ddd;
}

.ldap-settings .react-tagsinput-remove {
  color: #dd4b39;
}

.ldap-settings .react-tagsinput-input {
  width: auto;
  margin-top: 0;
}

.ldap-settings .react-tagsinput-input input {
  border: 0;
}

.ldap-settings .react-tagsinput-input input:focus {
  outline: 0;
}

.ldap-settings .configuration__type, .ldap-settings .server__type {
  width: 250px;
}

.ldap-settings .server__port {
  width: 80px;
}

.ldap-settings .ldap-role__cell:first-of-type {
  min-width: 250px;
  padding-left: 0;
}

.ldap-settings .ldap-role__cell:last-of-type {
  padding-right: 0;
}

.ldap-settings .ldap-role__cell-role {
  width: 200px;
}

.ldap-settings .ldap-search-login .react-tagsinput-tag {
  padding-top: 1px;
  padding-bottom: 1px;
}

.ldap-settings .ldap-search-login .react-tagsinput-input {
  padding-top: 2px;
  padding-bottom: 2px;
}

.ldap-settings .ldap-settings__accordion-arrow {
  float: right;
  margin-top: 4px !important;
  margin-right: 5px !important;
  font-size: 1.5em !important;
}

.ldap-settings .ldap-settings__accordion-title {
  margin-bottom: 5px !important;
  margin-left: 5px !important;
  line-height: 1.2em !important;
}

.ldap-settings .select-input-field .select-menu-renderer {
  cursor: pointer;
  font-size: .85em;
}

.ldap-settings .select-input-field .select-menu-renderer span {
  white-space: nowrap;
}

.ldap-settings .select-input-field .Select-menu-outer {
  z-index: 1100;
  width: auto;
}

.ldap-settings .ldap-settings-stepper-role-assignments--new-configuration {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Settings/Administration/LdapSettings/LdapSettings.css","webpack://./services/frontend/app/pages/Settings/Administration/LdapSettings/LdapSettings.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".ldap-settings .box-configurations {\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n  .ldap-settings .box-configuration {\n    margin-bottom: 12px;\n    margin-top: 0;\n  }\n  .ldap-settings .box-configuration:last-of-type {\n      margin-bottom: 0;\n    }\n  .ldap-settings .box-body-configuration {\n    background: #f5f5f5;\n  }\n  .ldap-settings .box-header-configuration {\n    cursor: pointer;\n  }\n  .ldap-settings .table-noborder > tbody > tr > td {\n      border: 0;\n    }\n  .ldap-settings .ldap-settings__select-cert {\n    min-width: 200px;\n  }\n  .ldap-settings .ldap-settings__account-suffixes--wrapper {\n    min-width: 250px;\n  }\n  .ldap-settings .react-tagsinput {\n    overflow: auto;\n  }\n  .ldap-settings .react-tagsinput-tag {\n    background: none;\n    border-color: #ddd;\n    color: inherit;\n  }\n  .ldap-settings .react-tagsinput-remove {\n    color: #dd4b39;\n  }\n  .ldap-settings .react-tagsinput-input {\n    margin-top: 0;\n    width: auto;\n  }\n  .ldap-settings .react-tagsinput-input input {\n    border: 0;\n  }\n  .ldap-settings .react-tagsinput-input input:focus {\n    outline: 0;\n  }\n  .ldap-settings .configuration__type {\n    width: 250px;\n  }\n  .ldap-settings .server__type {\n    width: 250px;\n  }\n  .ldap-settings .server__port {\n    width: 80px;\n  }\n  .ldap-settings .ldap-role__cell:first-of-type {\n      min-width: 250px;\n      padding-left: 0;\n    }\n  .ldap-settings .ldap-role__cell:last-of-type {\n      padding-right: 0;\n    }\n  .ldap-settings .ldap-role__cell-role {\n    width: 200px;\n  }\n  .ldap-settings .ldap-search-login .react-tagsinput-tag {\n      padding-top: 1px;\n      padding-bottom: 1px;\n    }\n  .ldap-settings .ldap-search-login .react-tagsinput-input {\n      padding-top: 2px;\n      padding-bottom: 2px;\n    }\n  .ldap-settings .ldap-settings__accordion-arrow {\n    float: right;\n    font-size: 1.5em !important;\n    margin-right: 5 !important;\n    margin-top: 4px !important;\n  }\n  .ldap-settings .ldap-settings__accordion-title {\n    line-height: 1.2em !important;\n    margin-bottom: 5px !important;\n    margin-left: 5px !important;\n  }\n  .ldap-settings .select-input-field .select-menu-renderer {\n      cursor: pointer;\n      font-size: 0.85em;\n    }\n  .ldap-settings .select-input-field .select-menu-renderer span {\n        white-space: nowrap;\n      }\n  .ldap-settings .select-input-field .Select-menu-outer {\n      width: auto;\n      z-index: 1100;\n    }\n  .ldap-settings .ldap-settings-stepper-role-assignments--new-configuration {\n    cursor: not-allowed;\n  }\n",".ldap-settings .box-configurations {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.ldap-settings .box-configuration {\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.ldap-settings .box-configuration:last-of-type {\n  margin-bottom: 0;\n}\n\n.ldap-settings .box-body-configuration {\n  background: #f5f5f5;\n}\n\n.ldap-settings .box-header-configuration {\n  cursor: pointer;\n}\n\n.ldap-settings .table-noborder > tbody > tr > td {\n  border: 0;\n}\n\n.ldap-settings .ldap-settings__select-cert {\n  min-width: 200px;\n}\n\n.ldap-settings .ldap-settings__account-suffixes--wrapper {\n  min-width: 250px;\n}\n\n.ldap-settings .react-tagsinput {\n  overflow: auto;\n}\n\n.ldap-settings .react-tagsinput-tag {\n  color: inherit;\n  background: none;\n  border-color: #ddd;\n}\n\n.ldap-settings .react-tagsinput-remove {\n  color: #dd4b39;\n}\n\n.ldap-settings .react-tagsinput-input {\n  width: auto;\n  margin-top: 0;\n}\n\n.ldap-settings .react-tagsinput-input input {\n  border: 0;\n}\n\n.ldap-settings .react-tagsinput-input input:focus {\n  outline: 0;\n}\n\n.ldap-settings .configuration__type, .ldap-settings .server__type {\n  width: 250px;\n}\n\n.ldap-settings .server__port {\n  width: 80px;\n}\n\n.ldap-settings .ldap-role__cell:first-of-type {\n  min-width: 250px;\n  padding-left: 0;\n}\n\n.ldap-settings .ldap-role__cell:last-of-type {\n  padding-right: 0;\n}\n\n.ldap-settings .ldap-role__cell-role {\n  width: 200px;\n}\n\n.ldap-settings .ldap-search-login .react-tagsinput-tag {\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n\n.ldap-settings .ldap-search-login .react-tagsinput-input {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.ldap-settings .ldap-settings__accordion-arrow {\n  float: right;\n  margin-top: 4px !important;\n  margin-right: 5px !important;\n  font-size: 1.5em !important;\n}\n\n.ldap-settings .ldap-settings__accordion-title {\n  margin-bottom: 5px !important;\n  margin-left: 5px !important;\n  line-height: 1.2em !important;\n}\n\n.ldap-settings .select-input-field .select-menu-renderer {\n  cursor: pointer;\n  font-size: .85em;\n}\n\n.ldap-settings .select-input-field .select-menu-renderer span {\n  white-space: nowrap;\n}\n\n.ldap-settings .select-input-field .Select-menu-outer {\n  z-index: 1100;\n  width: auto;\n}\n\n.ldap-settings .ldap-settings-stepper-role-assignments--new-configuration {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
